import React, { useCallback, useState } from 'react';
import { useFinancials } from 'context/FinancialsContext';
import { AdjustEBITDAChipStylesWrapper, StyledChip } from './AdjustEBITDAChip.styles';

const AdjustEBITDAChip = () => {
  const { useAdjustedEBITDA, setUseAdjustedEBITDA } = useFinancials();

  const [isHovered, setIsHovered] = useState(false);

  const handleClick = useCallback(() => {
    if (setUseAdjustedEBITDA) {
      setUseAdjustedEBITDA(!useAdjustedEBITDA);
    }
  }, [useAdjustedEBITDA, setUseAdjustedEBITDA]);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  return (
    <AdjustEBITDAChipStylesWrapper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {(useAdjustedEBITDA || isHovered) && (
        <StyledChip
          isSelected={!!useAdjustedEBITDA}
          label="Adjust"
          clickable
          color="primary"
          size="small"
          onClick={handleClick}
          variant="outlined"
        />
      )}
    </AdjustEBITDAChipStylesWrapper>
  );
};

export default AdjustEBITDAChip;
